import SvgMarkerIcon from './SvgMarkerIcon'

export default SvgMarkerIcon
